// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"V3-z","dimensionLabel":"W3-z","styleChooserControlWrapper":"X3-z","styleChooserControl":"Y3-z","disabled":"Z3-z","giftCard":"_3-z","styleChooserText":"a4-z"};